module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242af556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 559
// module chunks = 1